module.exports = __webpack_public_path__ + "UX5.png?c7dd5c0f964ac66474db6efb0aa2c163";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX5.png
// module id = 101
// module chunks = 0